import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import './index.scss';
export const CopyIcon = () =>
// <svg className="icon icon--copy" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
//   <rect className="stroke" height="8" width="8" x="6.5" y="10" />
//   <path className="stroke" d="M10 9.98438V6.5H18V14.5H14" />
// </svg>
/*#__PURE__*/
_jsx("svg", {
  className: "icon icon--copy",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    className: "stroke",
    d: "M4.66666 12.6667C3.93333 12.6667 3.33333 12.0667 3.33333 11.3333V4.66668C3.33333 3.93334 3.93333 3.33334 4.66666 3.33334H11.3333C12.0667 3.33334 12.6667 3.93334 12.6667 4.66668M8.66666 7.33334H15.3333C16.0697 7.33334 16.6667 7.9303 16.6667 8.66668V15.3333C16.6667 16.0697 16.0697 16.6667 15.3333 16.6667H8.66666C7.93028 16.6667 7.33333 16.0697 7.33333 15.3333V8.66668C7.33333 7.9303 7.93028 7.33334 8.66666 7.33334Z",
    strokeLinecap: "square"
  })
});
//# sourceMappingURL=index.js.map